import {
  LayoutDashboard,
  ClipboardList,
  Building2,
  ShieldCheck,
  Kanban,
  Rocket,
  Calendar,
  ListTodo,
  FolderOpen,
  Settings,
  User,
  Bell,
} from 'lucide-react';

/** Stage-gated founder nav per blueprint §2 */
export function getFounderNav(startup, flags = {}) {
  const s = startup || {};
  const stage = s.stage || 'prospect';
  const skip = s.skipOnboarding || s.entryPath === 'active_existing';
  const items = [
    { path: '/founder', label: 'Overview', icon: LayoutDashboard, end: true },
  ];

  if (skip) {
    items.push({
      path: '/founder/application/form',
      label: flags.needsApplyForm ? 'Apply form *' : 'Apply form',
      icon: ClipboardList,
    });
    items.push({ path: '/founder/company-profile', label: 'Company Profile', icon: Building2 });
    if (s.dueDiligenceIsOpen || flags.dueDiligenceIsOpen) {
      items.push({ path: '/founder/requests', label: 'Due Diligence', icon: ShieldCheck });
    }
    items.push({ path: '/founder/batch', label: 'Batch OS', icon: Rocket });
    items.push({ path: '/founder/batch/tasks', label: 'Tasks', icon: ListTodo });
    items.push({ path: '/founder/meetings', label: 'Meetings', icon: Calendar });
  } else {
    if (['prospect', 'applicant', 'accepted', 'active_batch', 'demo_day', 'graduated'].includes(stage)) {
      items.push({ path: '/founder/application', label: 'Application', icon: ClipboardList });
    }
    if (['accepted', 'active_batch', 'demo_day', 'graduated'].includes(stage)) {
      items.push({ path: '/founder/company-profile', label: 'Company Profile', icon: Building2 });
      items.push({ path: '/founder/onboarding', label: 'Onboarding', icon: Kanban });
      if (s.dueDiligenceIsOpen || flags.dueDiligenceIsOpen || stage !== 'prospect') {
        items.push({ path: '/founder/requests', label: 'Due Diligence', icon: ShieldCheck });
      }
    }
    if (['active_batch', 'demo_day', 'graduated'].includes(stage)) {
      items.push({ path: '/founder/batch', label: 'Batch OS', icon: Rocket });
      items.push({ path: '/founder/batch/tasks', label: 'Tasks', icon: ListTodo });
      items.push({ path: '/founder/meetings', label: 'Meetings', icon: Calendar });
    }
  }

  // Documents repository access for startup team
  items.push({ path: '/founder/documents', label: 'Documents', icon: FolderOpen });
  items.push({ path: '/founder/profile', label: 'Profile', icon: User });
  items.push({ path: '/notifications', label: 'Notifications', icon: Bell });
  items.push({ path: '/founder/settings', label: 'Settings', icon: Settings });
  return items;
}

export const FOUNDER_NAV = getFounderNav({ stage: 'accepted' });

export const FOUNDER_TITLES = {
  '/founder': 'Overview',
  '/founder/application': 'Application',
  '/founder/application/form': 'Apply form',
  '/founder/company-profile': 'Company Profile',
  '/founder/onboarding': 'Onboarding',
  '/founder/requests': 'Due Diligence',
  '/founder/requests/dd': 'Due Diligence',
  '/founder/documents': 'Documents Repository',
  '/founder/batch': 'Batch OS',
  '/founder/batch/tasks': 'Batch tasks',
  '/founder/meetings': 'Meetings',
  '/founder/profile': 'Profile',
  '/founder/settings': 'Settings',
  '/notifications': 'Notifications',
};
